(function (d, s, id) {
  let js; const rjs = d.getElementsByTagName(s)[0]
  if (d.getElementById(id)) return
  js = d.createElement(s)
  js.id = id
  js.src = 'https://cdn.retently.com/public/components/embed/sdk.min.js'
  rjs.parentNode.insertBefore(js, rjs)
}(document, 'script', 'retently-jssdk'))
